const NO_SCROLL_CLASS = 'no-scroll-behavior';

let enable = function() {
  document.documentElement.classList.remove(NO_SCROLL_CLASS);
};

let disable = function() {
  document.documentElement.classList.add(NO_SCROLL_CLASS);
};

export default {
  enable: enable,
  disable: disable
};
